import omitBy from 'lodash/omitBy'
import i18n from 'i18n-client'
import {BRANDS, LANGUAGES, URLS_TO_REDIRECT} from 'const'
import {getLang} from './stringUtils'
import {ALL_LANGUAGES} from '../const'
import {getLandingPageRoute} from './redirections'

export const isEn = () => i18n.language === 'en-US'

export const isDe = () => i18n.language === 'de-DE'

const {DE, FR, IT, EN} = LANGUAGES

const lang = getLang(window.location.search) || DE

// first language assigned as default
export const BRANDS_LANGUAGES = {
  // make all brands german by default
  ...Object.keys(BRANDS).reduce((acc, brand) => ({...acc, [brand]: [DE]}), {}),

  [BRANDS.bilan]: [FR],
  [BRANDS.illustre]: [FR],
  [BRANDS.lematin]: [FR],
  [BRANDS.lematindimanche]: [FR],
  [BRANDS.pme]: [FR],
  [BRANDS.twentyfourhours]: [FR],
  [BRANDS.tamedia]: [DE, FR],
  [BRANDS.lessentiel]: [DE, FR],
  [BRANDS.blick]: [DE, FR],
  [BRANDS.moonandstars]: [DE, IT],
  [BRANDS.programmzeitschriften]: [DE],
  [BRANDS.jobs]: [DE, FR, EN],
  [BRANDS.jobscout24]: [DE, FR, EN],
  [BRANDS.jobup]: [FR, DE, EN],
  [BRANDS.onelog]: ALL_LANGUAGES,
  [BRANDS.twentymin]: ALL_LANGUAGES,
  [BRANDS.zff]: [DE, FR, EN],
  [BRANDS.autodesjahres]: [DE, FR, IT],
  [BRANDS.watson]: [DE, FR],
}

export const NON_GERMAN_BRANDS_LANGUAGES = omitBy(BRANDS_LANGUAGES, ([defaultLanguage]) => defaultLanguage === DE)

export const getTranslationLanguage = (languages, defaultLanguage) => {
  const knownLanguage = languages.find(lang => lang === i18n.language)
  return knownLanguage || defaultLanguage
}

export const getAllowedT = (brand, t) => {
  const languages = BRANDS_LANGUAGES[brand]
  if (languages && languages.length) {
    const [defaultLanguage] = languages
    const fixedLanguage = getTranslationLanguage(languages, defaultLanguage)
    return i18n.getFixedT(fixedLanguage)
  }
  return t
}

export const getGeneralOrAllowedT = (brand, t, needToUseAllowedT) => {
  if (needToUseAllowedT) {
    return getAllowedT(brand, t)
  }
  return t
}

export const getGeneralOrAllowedLang = (brand, needToUseAllowedLang) => {
  if (needToUseAllowedLang) {
    const languages = BRANDS_LANGUAGES[brand]
    if (languages && languages.length) {
      const [defaultLanguage] = languages
      return getTranslationLanguage(languages, defaultLanguage)
    }
  }
  return getLang(window.location.search)
}

export const getAboutLink = (langParam = lang) => getLandingPageRoute(URLS_TO_REDIRECT.About, langParam)

export const getImpressumLink = () => getLandingPageRoute(URLS_TO_REDIRECT.Impressum)

export const getSupportLink = () => getLandingPageRoute(URLS_TO_REDIRECT.Support)

export const getAgbLink = () => getLandingPageRoute(URLS_TO_REDIRECT.AGB)

export const getDsbLink = () => getLandingPageRoute(URLS_TO_REDIRECT.PrivacyPolicy)

export const isAvailableLang = lang => ALL_LANGUAGES.includes(lang)

export const getLangByQueryOrBrand = (brand, langParam = lang) => {
  if (BRANDS_LANGUAGES[brand]) {
    return BRANDS_LANGUAGES[brand].includes(langParam) ? langParam : BRANDS_LANGUAGES[brand][0]
  }

  return DE
}
